//base Url of Api
export const baseUrl = "http://aichatbotbackend.antheminfotech.com/"  //"http://localhost:8081/"
//export const baseUrl = "http://localhost:8081/"